import asyncLoadView from 'utils/asyncLoadView/asyncLoadView';
import routeArgsToInt from 'router/utils/routeArgsToInt';
import translation from 'translation';
import SimpleNestedPage from 'layouts/nested/simple/SimpleNestedPage';

const dashboardRoutes = [
  {
    path: '/dashboards',
    component: SimpleNestedPage,
    meta: {
      routeName: {
        segmentName: () => translation.trc('sidebar', 'Dashboards')
      }
    },
    children: [
      {
        path: 'create',
        name: 'createDashboard',
        component: () => asyncLoadView(import('pages/dashboards/DashboardPage/CreateDashboardPage')),
        props: routeArgsToInt
      },
      {
        path: ':dashboardId(\\d+)',
        name: 'dashboardDetails',
        component: () => asyncLoadView(import('pages/dashboards/DashboardPage/DashboardPage')),
        props: routeArgsToInt
      },
      {
        path: ':dashboardId(\\d+)/aori',
        name: 'aoriDashboard',
        component: () => asyncLoadView(import('pages/aori/AoriDashboardPage')),
        props: routeArgsToInt,
        meta: {
          layout: 'no-sidebar',
          aoriOnly: true
        }
      }
    ]
  }
];

export default dashboardRoutes;
